// extracted by mini-css-extract-plugin
module.exports = {"row":"RadioList_row__2BkuX","column":"RadioList_column__1l-wp"};